import Alignment from './Alignment.vue'
import Table from './Table.vue'
export default {
  Alignment,
  Table,
}
